
























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import {
  MANAGE_SPACE_OPTIONS,
  MANAGE_TYPE_OPTIONS,
} from "@/resources/constants/sidebarMenu";
import ManageSpaceInSuperSpaceComponent from "@/app/components/manageSpace/components/superSpace/manageSpaceInSuperSpace.component.vue";

@Component({
  name: "space-card-component",
  components: {
    ManageSpaceInSuperSpaceComponent,
  },
})
export default class SpaceCardComponent extends mixins(NotificationEvent) {
  @Prop() space;
  @Prop({ default: true }) isSuperAdmin;
  @Prop({ default: [] }) spaces;
  confirmDelete = false;
  confirmDisabled = false;
  loadingDelete = false;
  loadingEnabled = false;
  showActions = false;
  activeManageSpace = false;
  goToUserList(space): void {
    /* if (this.isSuperAdmin)
      this.$router.push({ name: "users_list", params: { space: space } }); */
  }
  enableOrDisabledSpace(): void {
    this.loadingEnabled = true;
    if (this.isSuperAdmin)
      this.$store.dispatch(
        "SpaceStore/enableOrDisabledSpaceBySuperAdminAction",
        {
          spaceId: this.space.id,
          payload: {
            enabledBySuperAdmin: !this.space.enabledBySuperAdmin,
          },
          callback: (space) => {
            this.loadingEnabled = false;
            this.confirmDisabled = false;
            this.onSuccess(
              i18n.t("notifications.titles.success"),
              i18n.t("notifications.descriptions.spaceUpdate")
            );
          },
        }
      );
    else
      this.$store.dispatch("SpaceStore/enableOrDisabledSpaceAction", {
        spaceId: this.space.id,
        payload: {
          enabled: !this.space.enabled,
        },
        callback: (space) => {
          this.loadingEnabled = false;
          this.confirmDisabled = false;
          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.spaceUpdate")
          );
        },
      });
  }
  deleteSpace(): void {
    if (this.spaces.length <= 1) return;
    this.loadingDelete = true;
    this.$store.dispatch("SpaceStore/deleteSpaceAction", {
      spaceId: this.space.id,
      callback: () => {
        this.loadingDelete = false;
        this.confirmDelete = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.deleteSpace")
        );
      },
    });
  }
  openManageSpace(): void {
    if (this.isSuperAdmin)
      this.$store.dispatch("SpaceStore/getSpaceAction", {
        spaceId: this.space.id,
        callback: () => {
          this.$store.dispatch("FloatMenuStore/setManageSpaceAction", true);
          this.$store.dispatch(
            "SystemStore/setManageSpaceMenuActiveAction",
            MANAGE_SPACE_OPTIONS.CUSTOMIZE
          );
          this.$store.dispatch(
            "SystemStore/setManageModalTypeAction",
            MANAGE_TYPE_OPTIONS.SPACE
          );
        },
      });
    else {
      this.$store.dispatch("SpaceStore/getSpaceAction", {
        spaceId: this.space.id,
        callback: () => {
          this.activeManageSpace = true;
        },
      });
    }
  }
  closeModal() {
    if (this.$route.name === "multi_spaces") {
      this.activeManageSpace = false;
      this.$emit("reload");
    } else
      this.$store.dispatch("SpaceStore/getSpaceAction", {
        spaceId: localStorage.getItem("space_default"),
        callback: () => {
          this.activeManageSpace = false;
          this.$emit("reload");
        },
      });
  }
}
